<template>
    <layout>
    	<div class="row no-gutters">
            <div class="col-sm-12">
                <table-data
                    :route="url.getList"
                    :settings="table.settings"
                    :columns="table.columns"
                    :inlineFilters="table.filters"
                    :autoUpdateFilter="table.autoUpdateFilter"
                    :addParamsToUrl="table.addParamsToUrl"
                    :loadingMsg="table.loadingMsg"
                    :notFoundMsg="table.notFoundMsg"
                    :orderByTemplate="table.orderByTemplate"
                    tableClass="table-responsive-sm"
                    @error-load="showError"
                >
                    <template v-slot:filters="{ tableFilters, search }">
                        <form autocomplete="false" @submit.prevent="search" @keyup.enter="search">
                            <div class="row header">
                                <div class="col-12">
                                    <header-list
                                        :title="pageTitle"
                                        :placeholderSearch="searchPlaceholder"
                                        v-model="tableFilters.q"
                                        :routeAddName="`${moduleCode}.${pageID}.create`"
                                        :canAdd="canAdd"
                                        :addTitle="addTitle">
                                    </header-list>
                                </div>
                            </div>
                        </form>
                    </template>

                    <template v-slot:body="{row, index, remove}">
                        <!-- <td :class="table.columns[0].class">
                            <div class="photo lightbox" @click="() => showLightbox(index, lp_idx)"
                                :style="{ 'background-image': `url(${getImageUrl(row.photo)})` }">
                            </div>
                        </td> -->
                        <td :class="table.columns[0].class">
                            {{ columnValue(row, table.columns[0]) }}
                        </td>
                        <td :class="table.columns[1].class">
                            <div class="d-flex">
                                <!-- text-truncate -->
                                <span class="">
                                    {{ columnValue(row, table.columns[1]) }}
                                </span>
                            </div>
                        </td>
                        <td :class="table.columns[2].class">
                            <ul class="list-circle m-0 pl-3">
                              <li v-for="role in row.roles">{{role.name}}</li>
                            </ul>
                        </td>
                        <td :class="table.columns[3].class">
                            <i :class="{'fas fa-check text-success': row.active, 'fas fa-ban text-danger': !row.active, 'cursor-pointer': canChangeState}"  class="action" @click.prevent="changeState(row.id, index, row)"></i>
                        </td>
                        <column-actions
                            v-if="checkActions"
                            :routeEdit="`${moduleCode}.${pageID}.show`"
                            @delete="deleteItem"
                            :deleteMsgTemplate="`${pageID}.msg.confirm.delete-item`"
                            :canDetail="canDetail"
                            :canEdit="canEdit"
                            :canDelete="canDelete"
                            :row="row"
                            :index="index"
                            :callbackDelete="remove" />
                    </template>
                </table-data>
            </div>
    	</div>
    </layout>
</template>

<script>
	import GeneralMixin     from './../../mixin';

    export default {
        mixins: [
            GeneralMixin,
        ],
    	data() {
      		return {
                pageID: 'users',
      			pageTitle: 'List',
      			list: [],
      			table: {
                    columns: [
                        // {
                        //     label: '',
                        //     field:  '',
                        //     sortable: false,
                        //     class: 'photos d-none d-lg-table-cell'
                        // },
                        {
                            label: 'Nome',
                            field:  'name',
                            sortable: true,
                        },
                        {
                            label: 'E-mail',
                            field:  'email',
                            sortable: true,
                            class: 'text-break',
                        },
                        {
                            label: 'Perfil',
                            field:  null,
                            sortable: false,
                            class: 'd-none d-lg-table-cell',
                        },
                        {
                            label: 'Ativo',
                            field:  'active',
                            sortable: true,
                            class: 'text-center',
                        },
                        {
                            label: '',
                            field:  null,
                            sortable: false,
                            class: 'actions',
                        }
                    ],
                },
      		}
    	},
    	methods: {
            changeState: function(id, index, row)
            {
                if(this.canChangeState){
                    let msg = 'Deseja ' + (row.active ? 'bloquear' : 'desbloquear' ) + ' o utilizador <u>'+row.name+'<u>?'
                    this.$root.$emit('openConfirmation', {
                        id: id,
                        data: row,
                        text: msg,
                        callback: (itemId, itemData) => {
                            let formData = new FormData();
                            formData.append('_method', 'PUT');
                            this.$http.post(this.url.getState.replace(':id', id), formData)
                            .then(res => {
                                this.showMessage(res.data.data);
                                if(row){
                                    row.active = !row.active;
                                }
                            })
                            .catch(error => {
                                this.showHttpError(error);
                            })
                        }
                    });
                }
            }
    	}
  	}
</script>

<style scoped lang="scss">
.table tr:not(:last-child):not(.no-results) > td.photos {
    padding-top: 0.5rem;
}
.photos {
    padding-bottom: 0;
    vertical-align: middle;
    .photo {
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        border-radius: 16px;
        border: none;
        height: 35px;
        width: 35px;
        outline: 0;
        -webkit-transition: opacity .4s;
        transition: opacity .4s;
    }
}
	// .photo {
	// 	display: flex;
	// 	align-items: center;
	// 	justify-content: center;
	// }

	// .img-user{
	// 	max-width: 100px;
	// 	max-height: 100px;
	// }
</style>

